import React, { useEffect, useState, useRef } from "react";
//import LoadingOverlay from "react-loading-overlay";
//import RingLoader from "react-spinners/RingLoader";
import axios from "../../Utils/Axios";
import { useAlert } from "react-alert";
import { Link } from "react-router-dom";
import $ from "jquery";
import IsAllowed from "../../Utils/IsAllowed";

//import IsAllowed from "../Utils/IsAllowed";

function SideBar() {
  const [user, setUser] = useState({});
  //const [loading, setLoading] = useState(false);
  const alert = useAlert();
  useEffect(() => {
    getUserData();
  }, []);
  const getUserData = () => {
    //setLoading(true);
    axios(`Login/department_info`, {
      method: "GET",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.parse(localStorage.getItem("data")),
      },
    }).then((res) => {
      if (res.status === 200) {
        //setLoading(false);
        setUser(res.data.department);
      } else {
        //setLoading(false);
        alert.show(res.error);
      }
    });
  };
  function toggle() {
    $("body").toggleClass("sidebar-toggled");
    $(".sidebar").toggleClass("toggled");
    if ($(".sidebar").hasClass("toggled")) {
      $(".sidebar .collapse").collapse("hide");
    }
  }

  return (
    <ul
      class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion "
      id="accordionSidebar"
    >
      <Link
        class="sidebar-brand d-flex align-items-center justify-content-center"
        to="/"
      >
        <div class="sidebar-brand-icon ">
          {user && user.logo ? (
            <img src={user.logo} height="50px" className="p-2"></img>
          ) : (
            <img src="/no-image-icon.png" height="50px" className="p-2"></img>
          )}
        </div>
      </Link>

      <hr class="sidebar-divider my-0" />

      <li class="nav-item active">
        <Link class="nav-link" to="/">
          <i class="fas fa-fw fa-tachometer-alt"></i>
          <span>Dashboard</span>
        </Link>
      </li>

      <hr class="sidebar-divider"></hr>
      {(IsAllowed(["10102"]) || IsAllowed(["10101"])) && (
        <li class="nav-item">
          <a
            class="nav-link collapsed"
            data-toggle="collapse"
            data-target="#collapseOne"
            aria-expanded="true"
            aria-controls="collapseOne"
          >
            <i class="fa fa-bullhorn"></i>
            <span>RMA</span>
          </a>
          <div
            id="collapseOne"
            class="collapse"
            aria-labelledby="headingOne"
            data-parent="#accordionSidebar"
          >
            <div class=" py-2 collapse-inner rounded">
              {IsAllowed(["10101"]) && (
                <Link class="collapse-item" to="/jobs">
                  RMA
                </Link>
              )}
              {IsAllowed(["10102"]) && (
                <Link class="collapse-item" to="/add-jobs">
                  Add RMA
                </Link>
              )}
            </div>
          </div>
        </li>
      )}
      {(IsAllowed(["70102"]) || IsAllowed(["70101"])) && (
        <li class="nav-item">
          <a
            class="nav-link collapsed"
            data-toggle="collapse"
            data-target="#collapseSeven"
            aria-expanded="true"
            aria-controls="collapseSeven"
          >
            <i class="fa fa-tasks"></i>
            <span>Jobs</span>
          </a>
          <div
            id="collapseSeven"
            class="collapse"
            aria-labelledby="headingSeven"
            data-parent="#accordionSidebar"
          >
            <div class=" py-2 collapse-inner rounded">
              {IsAllowed(["70101"]) && (
                <Link class="collapse-item" to="/job-cards">
                  Jobs
                </Link>
              )}
              {IsAllowed(["70102"]) && (
                <Link class="collapse-item" to="/add-job-card">
                  Add Jobs
                </Link>
              )}
            </div>
          </div>
        </li>
      )}
      {(IsAllowed(["40102"]) || IsAllowed(["40101"])) && (
        <li class="nav-item">
          <a
            class="nav-link collapsed"
            data-toggle="collapse"
            data-target="#collapseFour"
            aria-expanded="true"
            aria-controls="collapseFour"
          >
            <i class="fa fa-shopping-cart"></i>
            <span>Purchase</span>
          </a>
          <div
            id="collapseFour"
            class="collapse"
            aria-labelledby="headingFour"
            data-parent="#accordionSidebar"
          >
            <div class=" py-2 collapse-inner rounded">
              {IsAllowed(["40101"]) && (
                <Link class="collapse-item" to="/purchase">
                  Purchase
                </Link>
              )}
              {IsAllowed(["40102"]) && (
                <Link class="collapse-item" to="/add-purchase">
                  Add Purchase
                </Link>
              )}
            </div>
          </div>
        </li>
      )}
      {(IsAllowed(["50102"]) || IsAllowed(["50101"])) && (
        <li class="nav-item">
          <a
            class="nav-link collapsed"
            data-toggle="collapse"
            data-target="#collapseFive"
            aria-expanded="true"
            aria-controls="collapseFive"
          >
            <i class="fas fa-ticket-alt"></i>
            <span>Inward</span>
          </a>
          <div
            id="collapseFive"
            class="collapse"
            aria-labelledby="headingFive"
            data-parent="#accordionSidebar"
          >
            <div class=" py-2 collapse-inner rounded">
              {IsAllowed(["50101"]) && (
                <Link class="collapse-item" to="/inward">
                  Inward
                </Link>
              )}
              {IsAllowed(["50102"]) && (
                <Link class="collapse-item" to="/add-inward">
                  Add Inward
                </Link>
              )}
            </div>
          </div>
        </li>
      )}
      {(IsAllowed(["60102"]) || IsAllowed(["60101"])) && (
        <li class="nav-item">
          <a
            class="nav-link collapsed"
            data-toggle="collapse"
            data-target="#collapseSix"
            aria-expanded="true"
            aria-controls="collapseSix"
          >
            <i class="fas fa-ticket-alt"></i>
            <span>OutWard</span>
          </a>
          <div
            id="collapseSix"
            class="collapse"
            aria-labelledby="headingSix"
            data-parent="#accordionSidebar"
          >
            <div class=" py-2 collapse-inner rounded">
              {IsAllowed(["60101"]) && (
                <Link class="collapse-item" to="/outward">
                  OutWard
                </Link>
              )}
              {IsAllowed(["60102"]) && (
                <Link class="collapse-item" to="/add-outward">
                  Add OutWard
                </Link>
              )}
            </div>
          </div>
        </li>
      )}

      {IsAllowed(["80101"]) && (
        <li class="nav-item">
          <a
            class="nav-link collapsed"
            data-toggle="collapse"
            data-target="#collapseEight"
            aria-expanded="true"
            aria-controls="collapseEight"
          >
            <i class="fa fa-comments"></i>
            <span>Feedbacks</span>
          </a>
          <div
            id="collapseEight"
            class="collapse"
            aria-labelledby="headingEight"
            data-parent="#accordionSidebar"
          >
            <div class=" py-2 collapse-inner rounded">
              {IsAllowed(["80101"]) && (
                <Link class="collapse-item" to="/feedbacks">
                  Feedbacks
                </Link>
              )}
            </div>
          </div>
        </li>
      )}
      {IsAllowed(["20201"]) && (
        <li class="nav-item">
          <a
            class="nav-link collapsed"
            data-toggle="collapse"
            data-target="#collapseTwo"
            aria-expanded="true"
            aria-controls="collapseTwo"
          >
            <i class="fa fa-sitemap"></i>
            <span>Catalogs</span>
          </a>
          <div
            id="collapseTwo"
            class="collapse"
            aria-labelledby="headingTwo"
            data-parent="#accordionSidebar"
          >
            <div class=" py-2 collapse-inner rounded">
              {IsAllowed(["20201"]) && (
                <Link class="collapse-item" to="/departments">
                  Departments
                </Link>
              )}
            </div>
          </div>
        </li>
      )}

      {(IsAllowed(["30101"]) || IsAllowed(["30201"])) && (
        <li class="nav-item">
          <a
            class="nav-link collapsed"
            data-toggle="collapse"
            data-target="#collapseThree"
            aria-expanded="true"
            aria-controls="collapseThree"
          >
            <i class="fa fa-users"></i>
            <span>User Management</span>
          </a>
          <div
            id="collapseThree"
            class="collapse"
            aria-labelledby="headingThree"
            data-parent="#accordionSidebar"
          >
            <div class=" py-2 collapse-inner rounded">
              {IsAllowed(["30101"]) && (
                <Link class="collapse-item" to="/users">
                  Users
                </Link>
              )}
              {IsAllowed(["30201"]) && (
                <Link class="collapse-item" to="/roles">
                  Roles
                </Link>
              )}
            </div>
          </div>
        </li>
      )}

      <div class="text-center d-none d-md-inline">
        <button
          class="rounded-circle border-0"
          onClick={toggle}
          id="sidebarToggle"
        ></button>
      </div>
    </ul>
  );
}

export default SideBar;
